module.exports = __webpack_public_path__ + "static/media/cross.07c97899.svg";